<template>

	<div class="grid">
		<div class="col-12 md:col-6">
			<div class="card fluid">
                <form @submit.prevent="handleSubmit(!v$.$invalid)">

                        <label for="naziv" :class="{'p-error':v$.name.$invalid && submitted}">Name*</label>
                        <InputText id="naziv" type="text" v-model="v$.name.$model" :class="{'p-invalid':v$.name.$invalid && submitted}" />
                        <small v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">{{v$.name.required.$message.replace('Value', 'Name')}}</small>

                    

                    <span class="p-float-label">
                        <InputText id="street" type="text" v-model="street" />
                        <label for="street">Ulica</label>
                    </span>    


                    <input type="text" v-model="street1">
                    <label>Hišna št.:</label>
                    <input type="text" v-model="housenumber" required>
                    <label>Poštna št.:</label>
                    <input type="text" v-model="zip" required>
                    <label>Pošta:</label>
                    <input type="text" v-model="city" required>    
                    <label>Država:</label>
                    <input type="text" v-model="country" required>    
                    <label>EVSE-id:</label>
                    <input type="text" v-model="evseid">    
                    <label>Javna:</label>
                    <input type="checkbox" v-model="ispublic">
                    <label>Deluje:</label>
                    <input type="checkbox" v-model="isoperational">
                    <label>Začasno izključena:</label>
                    <input type="checkbox" v-model="temporaryclosed">      
                    <label>Lat:</label>
                    <input type="number" step="0.01" v-model="lat">   
                    <label>Lon:</label>
                    <input type="number" step="0.01" v-model="long">           
                    <label>Zaznamki.:</label>
                    <textarea v-model="notes"></textarea> 

                    <select v-model="associatedinftype">
                        <option value=-1></option>
                        <option value=0>airport</option>
                        <option value=1>carPark</option>
                        <option value=2>carRentalStation</option>
                        <option value=3>lorryParkingSite</option>
                        <option value=4>other</option>
                        <option value=5>parkingSite</option>
                        <option value=6>publicTransportDepot</option>
                        <option value=7>field</option>
                    </select>

                    <label>Število parkirnih mest za avtomovile:</label>
                    <input type="number" v-model="carparkingcapacity">  
                    <label>Število parkirnih mest za tovornjake:</label>
                    <input type="number" v-model="truckparkingcapacity">  
                    <label>Število parkirnih mest za kolesa:</label>
                    <input type="number" v-model="bikeparkingcapacity">  
                    <button>Add Energy Site</button>     
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import createHttp from "@/services/http";
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            name: '',
            street: '',
            street1: '',
            housenumber: '',
            zip: '',
            city: '',
            country: '',
            evseid: '',
            ispublic: false,
            isoperational: false,
            temporaryclosed: false,
            lat:null,
            long:null,
            notes:'',
            contactperson:'',
            responsibleperson:'', 
            contactemail: '',
            contactphone: '',
            associatedinftype: null,
            carparkingcapacity: null,
            truckparkingcapacity: null,
            bikeparkingcapacity: null,
            submitted: false,
            ispersononsite : false
        }
    },
    validations() {
        return {
            name: {
                required
            },
            street: {
                required
            }
        }
    },       
    methods: {
        async handleSubmit(isFormValid) {

            //console.log('klicem submit:' + isFormValid)
            this.submitted = true;

            if (!isFormValid) {
                return;
            }

            let energySite = {
                name: this.name,
                street: this.street,
                street1: this.street1,
                housenumber: this.housenumber,
                zip: this.zip,
                city: this.city,
                country: this.country,
                evseid: this.evseid,
                ispublic: this.ispublic,
                isoperational: this.isoperational,
                temporaryclosed: this.temporaryclosed,
                lat: this.lat,
                long: this.long,
                notes: this.notes,
                contactemail: this.contactemail,
                contactphone: this.contactphone,
                associatedinftype: this.associatedinftype,
                carparkingcapacity: this.carparkingcapacity,
                truckparkingcapacity: this.truckparkingcapacity,
                bikeparkingcapacity: this.bikeparkingcapacity,
                ispersononsite: this.ispersononsite
            }

            //console.log(energySite)
            
            const http = createHttp(true); 
            const response = await http.post(process.env.VUE_APP_API_FOLDER + "/InsertUpdateEnergySite", energySite);
/*
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(energySite)
            };
            const response = await fetch("https://localhost:44378/Infrastructure/InsertUpdateEnergySite", requestOptions);
            const data = await response.json();
*/
//console.log('response na insert')
//console.log(response)

            if(response.status==200) {
                //console.log('VSE JE OK!!!')
                this.$router.push('/')
            } else {
                console.log('ERROR!!!')
            }

            //console.log(response)
            

/*
            fetch('https://localhost:44378/Infrastructure/InsertUpdateEnergySite', {
                method:'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify(energySite)
            }).then(() => {
                this.$router.push('/')
            }).catch((err) => console.log(err))
            */
        }
    }
}
</script>

<style>
  
</style>